"use client";

import { Input } from "@/components/ui/input";
import { useState } from "react";
import AuthLayout, { AuthButton } from "../AuthLayout";
import Link from "next/link";
import { fetchApi, handleApiError } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      const response = await fetchApi("/auth/forgot-password/", {
        method: "POST",
        body: JSON.stringify({
          email,
        }),
      });
      setSuccessMessage(
        "Password reset instructions have been sent to your email."
      );
    } catch (error) {
      console.error("Password reset request failed:", error);
      setErrorMessage(
        error instanceof Error ? error.message : "Password reset request failed"
      );
    }
  };

  return (
    <AuthLayout
      title="Password Reset"
      subtitle="Enter your email to reset your password."
      onSubmit={handleSubmit}
    >
      <div className="space-y-2">
        <Input
          id="email"
          placeholder="Your email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
        />
      </div>
      <AuthButton type="submit">Reset Password</AuthButton>
      <div className="text-center text-sm">
        Remember your password?{" "}
        <Link
          href="/auth/signin"
          className="text-gray-900 hover:text-gray-700 underline"
        >
          Sign In
        </Link>
      </div>
      {successMessage && <div className="text-green-500">{successMessage}</div>}
      {errorMessage && <div className="text-red-500">{errorMessage}</div>}
    </AuthLayout>
  );
}
